import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import SettingsPage from '../partials/SettingsPage';
import LoadingSpinner from '../partials/LoadingSpinner';
import PageHeader from '../partials/PageHeader';
import WroListItem from './WroListItem';
import RemoveWroDialog from './RemoveWroDialog';

import { Button, Text, H4, H3, H2, Dropdown, Panel, Table, Small, Box } from '@bigcommerce/big-design';

import { warehouseReceivingOrdersIndex } from '../../redux/actions/warehouseReceivingOrders';

const PrintWros = ({ payload, loadWros, warehouseReceivingOrders }) => {
  const [showRemoveWroDialog, setShowRemoveWroDialog] = useState(false);
  const [modifyItemId, setModifyItemId] = useState(null);


  useEffect(() => {
    loadWros(payload);
  }, []);

  const description = () => {
    return(
      <> 
        <Text>Print Warehouse Receiving Orders from the Supplier Purchase Orders app.</Text>
        <Text>When a purchase order is received, the received items will appear here, ready for printing. Click the "View and Print" button to select print options. The shared print data shown here is only stored for two weeks before it is automatically deleted.</Text>
        <Text>Click a warehouse receiving order's "Remove" button when you're done with it to remove it from this list.</Text>
        <Small>Have questions or need some help? Contact us at <a href="mailto:support@athousandapps.com">support@athousandapps.com</a></Small>
      </>
    )
  }

  return(
    <>
      <PageHeader stripeBackground='#fdeec0' helpLink="bigcommerce/print-warehouse-receiving-order-labels/" />
      <SettingsPage title="Print from WROs" description={description()}>
        <Panel>
          { warehouseReceivingOrders.status !== 'success' &&
            <LoadingSpinner statusText="Loading Warehouse Receiving Orders" />
          }
          { warehouseReceivingOrders.status === 'success' &&
            <>
              { (warehouseReceivingOrders.warehouseReceivingOrders.length === 0) &&
                <Box
                  backgroundColor="warning10"
                  border="box"
                  borderRadius="normal"
                  padding="medium"
                >
                  <div className="text-center">
                    <Text>No outstanding warehouse receiving order prints. Receive more orders in the Supplier Purchase Orders app to see them listed here.</Text>
                  </div>
                </Box>
              }

              { warehouseReceivingOrders.warehouseReceivingOrders.map(order => 
                <WroListItem 
                  order={order} 
                  setShowRemoveWroDialog={setShowRemoveWroDialog}
                  setModifyItemId={setModifyItemId}
                />
              )}
            </>
          }
        </Panel>
      </SettingsPage>

      { showRemoveWroDialog &&
        <RemoveWroDialog
          payload={payload}
          wroId={modifyItemId}
          showRemoveWroDialog={showRemoveWroDialog}
          setShowRemoveWroDialog={setShowRemoveWroDialog}
        />
      }

    </>
  )
}

const mapStateToProps = state => ({
  warehouseReceivingOrders: state.warehouseReceivingOrders,
});

const mapDispatchToProps = (dispatch) => ({
  loadWros: (payload) => dispatch(warehouseReceivingOrdersIndex(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PrintWros);